import React, { useEffect, useRef, useState } from "react";
import Table from "../Table/Table";
import { getCallLogsAPI } from "../../API/Api";
import moment from "moment";
import usePaginatedData from "../Utils/UsePagination";
import { useSelector } from "react-redux";

export default function CallLogTable(){
  const modalState = useSelector((state) => state?.login);
  const LeadsData = modalState?.modalData?.rowdata || {};
  const isFirstRender = useRef(true);
  const filterTimeout = useRef();

  const initialFilterState = {
    p: 1,
    records: 10,
    leadId: LeadsData._id,
  };

  const [filterObject, setFilterObject] = useState({ ...initialFilterState });

  const {
    filterData: CallLogData,
    fetchData,
  } = usePaginatedData(1, 50, getCallLogsAPI, filterObject);

  const filterRecords = () => {
    if (filterTimeout.current) {
      clearTimeout(filterTimeout.current);
    }
    filterTimeout.current = setTimeout(async () => {
      await fetchData({ ...filterObject });
      filterTimeout.current = null;
    }, 1500);

    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
      }
    };
  };

  useEffect(() => {
      if (isFirstRender.current) {
        isFirstRender.current = false; 
        return;
      }
      filterRecords();
    }, [filterObject]);

  const formatTalkTime = (startStr, endStr) => {
    const start = moment(startStr, "DD-MM-YYYY hh:mm:ss A");
    const end = moment(endStr, "DD-MM-YYYY hh:mm:ss A");
    if (!start.isValid() || !end.isValid()) return "--:--";

    const diffSec = Math.max(0, end.diff(start, "seconds"));
    const mins = Math.floor(diffSec / 60);
    const secs = diffSec % 60;
    return `${mins} min ${secs} sec`;
  };

    
    const tableColumns = [
          {
            field: "First_Name",
            header: "First Name",
            style: true,
            body: (row) => (
              <h6>{row?.userId?.first_name ? row?.userId?.first_name : "--"}</h6>
            ),
          },
          {
            field: "Last_Name",
            header: "Last Name",
            style: true,
            body: (row) => (
              <h6>{row?.userId?.last_name ? row?.userId?.last_name : "--"}</h6>
            ),
          },
          {
            field: "formattedTalkTime",
            header: "Talk Time",
            style: true,
            body: (row) => (
                <h6>
                {formatTalkTime(row?.callStart, row?.callEnd)}
                </h6>
            ),
          },
          {
            field: "follow_date",
            header: "Follow Date",
            style: true,
            body: (row) => <h6>{row?.followDate ? row?.followDate : "--"}</h6>,
          },
          {
            field: "follow_time",
            header: "Follow Time",
            style: true,
            body: (row) => <h6>{row?.followTime ? row?.followTime : "--"}</h6>,
          },
          {
            field: "lead_status",
            header: "Lead Status",
            style: true,
            body: (row) => <h6>{row?.leadStatus ? row?.leadStatus : "--"}</h6>,
          },
          {
            field: "remark",
            header: "Remark",
            style: true,
            body: (row) => <h6>{row?.remark ? row?.remark : "--"}</h6>,
          },
    ];
    return (
        <>
        {/* call log table */}
        <div className="p-1 m-3">
            <Table
                columns={tableColumns}
                data={CallLogData}
                paginatorCheck={false}
            />
        </div>
        </>
    )
}